import { carregarEmpregadosDaStore } from '@/integracoes/src-next/catalogos/catalogo-empregado.vuex'
import { empregadoNaoDesligado, empregadoDesligado, empregadoPossuiBancoDeHoras } from '@next/modulos/estrutura-de-ponto-da-empresa/empregado/catalogo/criterios-empregado'
import { freezeItems } from './freezeItems'

const minimalOnly = [
  'id', 'code', 'name', 'resignation'
]

const defaultOnly = [
  'closing_date', 'id', 'code', 'name',
  'resignation', 'company', 'work_hour_bank_rules',
  'phoneclock_password', 'funct', 'custom_rules',
  'sincronizar_com_repp', 'id_repp'
]

export default {
  namespaced: true,
  state: { items: [], loading: false, pronto: false, atualizando: false, erro: null, sincronizadoEm: null },
  getters: {
    all: state => state.items,
    onlyNotFired: state => state.items.filter(empregadoNaoDesligado),
    onlyFired: state => state.items.filter(empregadoDesligado),
    onlyWithWhb: state => state.items.filter(empregadoPossuiBancoDeHoras),
    onlyWithWhbAndNotFired: state => state.items.filter(i => empregadoNaoDesligado(i) && empregadoPossuiBancoDeHoras(i)),
    aindaFaltaMostrarPaginas: () => false
  },
  mutations: {
    resetItems (state) {
      Object.assign(state, { items: [], loading: false, pronto: false, atualizando: false, erro: null, sincronizadoEm: null })
    },
    publicarCatalogo (state, { items, ...estado }) {
      if (items !== undefined) state.items = freezeItems(items)
      Object.assign(state, estado)
    }
  },
  actions: {
    async fetchItems ({ state, dispatch }, payload = {}) {
      const parametros = payload.withParams || {}
      const campos = payload.withFields || []
      const parametrosCanonicos = { active: 'false', order_by: 'name', fired: 'all', noderef: 'bulk' }
      const possuiRecorte = Object.entries(parametros).some(([chave, valor]) => String(valor) !== parametrosCanonicos[chave])
      if (possuiRecorte || campos.some(campo => !['id', 'name', 'code', 'resignation', 'closing_date', 'admission', 'company', 'funct', 'sincronizar_com_repp', 'custom_rules', 'work_hour_bank_rules'].includes(campo))) {
        return dispatch('consultarItensEspecificos', payload)
      }
      await carregarEmpregadosDaStore(this, payload.fullReload === true)
      return state.items
    },
    async consultarItensEspecificos (contexto, payload = {}) {
      const { API, retryRequest } = await import('src/services')
      const campos = payload.withMinimalInformation ? minimalOnly : defaultOnly
      const resultado = await retryRequest(API.employee.get, {
        fields: JSON.stringify([...new Set([...campos, ...(payload.withFields || [])])]),
        active: 'false', order_by: 'name', fired: 'all', noderef: 'bulk',
        ...(payload.withParams || {})
      })
      return resultado.body?.success || []
    },
    async fetchItemsComPaginacao (contexto, payload = {}) {
      const { API, retryRequest } = await import('src/services')
      const campos = payload.withMinimalInformation ? minimalOnly : defaultOnly
      const page = payload.page || 0
      const resultado = await retryRequest(API.employee.get, {
        fields: JSON.stringify([...new Set([...campos, ...(payload.withFields || ['first_work_day'])])]),
        active: 'false', order_by: 'name', fired: 'all', noderef: 'bulk', page, per_page: 30,
        ...(payload.search ? { search: JSON.stringify({ name_code_phoneclock_password: payload.search }) } : {}),
        ...(payload.withParams || {})
      })
      return { items: resultado.body?.success || [], page, totalPages: resultado.body?.totalPages || 0 }
    }
  }
}
